module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e151019"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2986",
      "id": "d14e500"
    }
  }, [_c('b', [_vm._v("PART I")])])]), _vm._v(" "), _c('p', {
    staticClass: "h5",
    attrs: {
      "id": "d7e151519"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2986",
      "id": "d14e504"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIFE, THE ")]), _vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE, AND THE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOD ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d7e152319"
    }
  }, [_c('i', [_vm._v("And [Isaac] said, “Here are the fire and the wood,"), _c('br'), _vm._v("but where is the lamb for the offering?” …"), _c('br'), _vm._v("Abraham stretched out his hand,"), _c('br'), _vm._v("and took the knife.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr13",
    attrs: {
      "id": "d7e154119"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENESIS 22:7–9 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a4e0c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Auth_ISBN9781402790959_epub_c11_r1.vue
// module id = 87
// module chunks = 0